export const sanitizeUrl = (url) => {
    try {
        const urlObj = new URL(url);
        return `${urlObj.origin}${urlObj.pathname}`;
    }
    catch {
        return '[invalid URL]';
    }
};
export const getFetchErrorMessage = (error) => {
    if (!(error instanceof Error)) {
        return 'Unknown error';
    }
    if (error.name === 'AbortError') {
        return 'Request was aborted (timeout or cancelled)';
    }
    // Check for nested cause (common in Node.js fetch errors)
    if ('cause' in error && error.cause instanceof Error) {
        return error.cause.message;
    }
    return error.message;
};
